const account1 = {
	accountId: '214',
	accountName: 'C. Cash & short term deposits 1',
	accountDesignation: 5,
	assertions: [
		{
			assertionId: '1',
			assertionAbbreviation: 'C',
			inherentRiskTypeId: 1
		},
		{
			assertionId: '2',
			assertionAbbreviation: 'E/O',
			inherentRiskTypeId: null
		},
		{
			assertionId: '3',
			assertionAbbreviation: 'M/V',
			inherentRiskTypeId: 1
		},
		{
			assertionId: '4',
			assertionAbbreviation: 'R&O',
			inherentRiskTypeId: 1
		},
		{
			assertionId: '5',
			assertionAbbreviation: 'P&D',
			inherentRiskTypeId: 2
		}
	],
	groupComponentAccount: {
		id: 8,
		rationale:
			'Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim. Donec pede justo, fringilla vel, aliquet nec, vulputate eget, arcu. In enim justo, rhoncus ut, imperdiet a, venenatis vitae, justo. Nullam dictum felis eu pede mollis pretium. Integer tincidunt. Cras dapibus. Vivamus elementum semper nisi. Aenean vulputate eleifend tellus. Aenean leo ligula, porttitor eu, consequat vitae, eleifend ac, enim. Aliquam lorem ante, dapibus in, viverra quis, feugiat a, tellus. Phasellus viverra nulla ut metus varius laoreet. Quisque rutrum. Aenean imperdiet. Etiam ultricies nisi vel augue. Curabitur ullamcorper ultricies nisi. Nam eget dui. Etiam rhoncus. Maecenas tempus, tellus eget condimentum rhoncus, sem quam semper libero, sit amet adipiscing sem neque sed ipsum. Nam quam nunc, blandit vel, luctus pulvinar, hendrerit id, lorem. Maecenas nec odio et ante tincidunt tempus. Donec vitae sapien ut libero venenatis faucibus. Nullam quis ante. Etiam sit amet orci eget eros faucibus tincidunt. Duis leo. Sed fringilla mauris sit amet nibh. Donec sodales sagittis magna. Sed consequat, leo eget bibendum sodales, augue velit cursus nunc, quis gravida magna mi a libero. Fusce vulputate eleifend sapien. Vestibulum purus quam, scelerisque ut, mollis sed, nonummy id, metus. Nullam accumsan lorem in dui. Cras ultricies mi eu turpis hendrerit fringilla. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia Curae; In ac dui quis mi consectetuer lacinia. Nam pretium turpis et arcu. Duis arcu tortor, suscipit eget, imperdiet nec, imperdiet iaculis, ipsum. Sed aliquam ultrices mauris. Integer ante arcu, accumsan a, consectetuer eget, posuere ut, mauris. Praesent adipiscing. Phasellus ullamcorper ipsum rutrum nunc. Nunc nonummy metus. Vestibulum volutpat pretium libero. Cras id dui. Aenean ut eros et nisl sagittis vestibulum. Nullam nulla eros, ultricies sit amet, nonummy id, imperdiet feugiat, pede. Sed lectus. Donec mollis hendrerit risus. Phasellus nec sem in justo pellentesque facilisis. Etiam imperdiet imperdiet orci. Nunc nec neque. Phasellus leo dolor, tempus non, auctor et, hendrerit quis, nisi. Curabitur ligula sapien, tincidunt non, euismod vitae, posuere imperdiet, leo. Maecenas malesuada. Praesent congue erat at massa. Sed cursus turpis vitae tortor. Donec posuere vulputate arcu. Phasellus accumsan cursus velit. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia Curae; Sed aliquam, nisi quis porttitor congue, elit erat euismod orci, ac placerat dolor lectus quis orci. Phasellus consectetuer vestibulum elit. Aenean tellus metus, bibendum sed, posuere ac, mattis non, nunc. Vestibulum fringilla pede sit amet augue. In turpis. Pellentesque posuere. Praesent turpis. Aenean posuere, tortor sed cursus feugiat, nunc augue blandit nunc, eu sollicitudin urna dolor sagittis lacus. Donec elit libero, sodales nec, volutpat a, suscipit non, turpis. Nullam sagittis. Suspendisse pulvinar, augue ac venenatis condimentum, sem libero volutpat nibh, nec pellentesque velit pede quis nunc. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia Curae; Fusce id purus. Ut varius tincidunt libero. Phasellus dolor. Maecenas vestibulum mollis diam. Pellentesque ut neque. Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas. In dui magna, posuere eget, vestibulum et, tempor auctor, justo. In ac felis quis tortor malesuada pretium. Pellentesque auctor neque nec urna. Proin sapien ipsum, porta a, auctor quis, euismod ut, mi. Aenean viverra rhoncus pede. Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas. Ut non enim eleifend felis pretium feugiat. Vivamus quis mi. Phasellus a est. Phas'
	},
	relatedAccounts: [],
	groupRiskStatusId: 4,
	isPrimaryAccount: true,
	pspIndexes: []
};

const account2 = {
	accountId: '212',
	accountName:
		'E. Trade accounts receivable accounts receivable accounts receivable accounts receivable accounts receivable accounts receivable accounts receivable accounts receivable accounts receivable accounts receivable accounts receivable',
	accountDesignation: 2,
	assertions: [
		{
			assertionId: '1',
			assertionAbbreviation: 'C',
			inherentRiskTypeId: 2
		},
		{
			assertionId: '2',
			assertionAbbreviation: 'E/O',
			inherentRiskTypeId: 1
		},
		{
			assertionId: '3',
			assertionAbbreviation: 'M/V',
			inherentRiskTypeId: 2
		},
		{
			assertionId: '4',
			assertionAbbreviation: 'R&O',
			inherentRiskTypeId: null
		},
		{
			assertionId: '5',
			assertionAbbreviation: 'P&D',
			inherentRiskTypeId: 1
		}
	],
	relatedAccounts: [],
	groupRiskStatusId: 1,
	isPrimaryAccount: true,
	groupComponentAccount: {
		id: 9,
		rationale: null
	},
	pspIndexes: [
		{
			pspIndexID: 1,
			pspIndexTitle: 'JKL PSP Indexes 04 JKL PSP Indexes 04 JKL PSP Indexes 04 JKL PSP Indexes 04 JKL PSP Indexes 04 JKL PSP Indexes 04 JKL PSP Indexes 04 JKL PSP Indexes 04 JKL PSP Indexes 04 '
		},
		{
			pspIndexID: 2,
			pspIndexTitle: 'MNO PSP Indexes 05'
		}
	]
};

const account3 = {
	accountId: '215',
	accountName: 'F. Inventory',
	accountDesignation: 1,
	assertions: [
		{
			assertionId: '1',
			assertionAbbreviation: 'C',
			inherentRiskTypeId: 1
		},
		{
			assertionId: '2',
			assertionAbbreviation: 'E/O',
			inherentRiskTypeId: null
		},
		{
			assertionId: '3',
			assertionAbbreviation: 'M/V',
			inherentRiskTypeId: 1
		},
		{
			assertionId: '4',
			assertionAbbreviation: 'R&O',
			inherentRiskTypeId: 2
		},
		{
			assertionId: '5',
			assertionAbbreviation: 'P&D',
			inherentRiskTypeId: 2
		}
	],
	relatedAccounts: [account1, account2, account1, account2, account1, account2, account1, account2],
	groupRiskStatusId: 5,
	isPrimaryAccount: true,
	pspIndexes: [
		{
			pspIndexID: 1,
			pspIndexTitle: 'ABC PSP Indexes 01'
		},
		{
			pspIndexID: 2,
			pspIndexTitle: 'GHI PSP Indexes 03'
		},
		{
			pspIndexID: 3,
			pspIndexTitle: 'LoremLorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum is simply dummy text of the printing and typesetting industry.  Ipsum is simply dummy text of the printing and typesetting industry. '
		},
		{
			pspIndexID: 4,
			pspIndexTitle: 'GHI PSP Indexes 05'
		},
		{
			pspIndexID: 5,
			pspIndexTitle: 'ABC PSP Indexes 06'
		},
		{
			pspIndexID: 6,
			pspIndexTitle: 'GHI PSP Indexes 07'
		},
		{
			pspIndexID: 7,
			pspIndexTitle: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum is simply dummy text of the printing and typesetting industry. '
		},
		{
			pspIndexID: 8,
			pspIndexTitle: 'GHI PSP Indexes 09'
		},
		{
			pspIndexID: 9,
			pspIndexTitle: 'ABC PSP Indexes 10'
		},
		{
			pspIndexID: 10,
			pspIndexTitle: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry.'
		},
		{
			pspIndexID: 11,
			pspIndexTitle: 'ABC PSP Indexes 12'
		},
		{
			pspIndexID: 12,
			pspIndexTitle: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry.'
		}
	]
};

const account4 = {
	accountId: '215',
	accountName: 'C. Short deposits',
	accountDesignation: 5,
	assertions: [
		{
			assertionId: '1',
			assertionAbbreviation: 'C',
			inherentRiskTypeId: 1
		},
		{
			assertionId: '2',
			assertionAbbreviation: 'E/O',
			inherentRiskTypeId: null
		},
		{
			assertionId: '3',
			assertionAbbreviation: 'M/V',
			inherentRiskTypeId: 1
		},
		{
			assertionId: '4',
			assertionAbbreviation: 'R&O',
			inherentRiskTypeId: 1
		},
		{
			assertionId: '5',
			assertionAbbreviation: 'P&D',
			inherentRiskTypeId: 2
		}
	],
	groupComponentAccount: {
		id: 8,
		rationale:
			'Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim. Donec pede justo, fringilla vel, aliquet nec, vulputate eget, arcu. In enim justo, rhoncus ut, imperdiet a, venenatis vitae, justo. Nullam dictum felis eu pede mollis pretium. Integer tincidunt. Cras dapibus. Vivamus elementum semper nisi. Aenean vulputate eleifend tellus. Aenean leo ligula, porttitor eu, consequat vitae, eleifend ac, enim. Aliquam lorem ante, dapibus in, viverra quis, feugiat a, tellus. Phasellus viverra nulla ut metus varius laoreet. Quisque rutrum. Aenean imperdiet. Etiam ultricies nisi vel augue. Curabitur ullamcorper ultricies nisi. Nam eget dui. Etiam rhoncus. Maecenas tempus, tellus eget condimentum rhoncus, sem quam semper libero, sit amet adipiscing sem neque sed ipsum. Nam quam nunc, blandit vel, luctus pulvinar, hendrerit id, lorem. Maecenas nec odio et ante tincidunt tempus. Donec vitae sapien ut libero venenatis faucibus. Nullam quis ante. Etiam sit amet orci eget eros faucibus tincidunt. Duis leo. Sed fringilla mauris sit amet nibh. Donec sodales sagittis magna. Sed consequat, leo eget bibendum sodales, augue velit cursus nunc, quis gravida magna mi a libero. Fusce vulputate eleifend sapien. Vestibulum purus quam, scelerisque ut, mollis sed, nonummy id, metus. Nullam accumsan lorem in dui. Cras ultricies mi eu turpis hendrerit fringilla. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia Curae; In ac dui quis mi consectetuer lacinia. Nam pretium turpis et arcu. Duis arcu tortor, suscipit eget, imperdiet nec, imperdiet iaculis, ipsum. Sed aliquam ultrices mauris. Integer ante arcu, accumsan a, consectetuer eget, posuere ut, mauris. Praesent adipiscing. Phasellus ullamcorper ipsum rutrum nunc. Nunc nonummy metus. Vestibulum volutpat pretium libero. Cras id dui. Aenean ut eros et nisl sagittis vestibulum. Nullam nulla eros, ultricies sit amet, nonummy id, imperdiet feugiat, pede. Sed lectus. Donec mollis hendrerit risus. Phasellus nec sem in justo pellentesque facilisis. Etiam imperdiet imperdiet orci. Nunc nec neque. Phasellus leo dolor, tempus non, auctor et, hendrerit quis, nisi. Curabitur ligula sapien, tincidunt non, euismod vitae, posuere imperdiet, leo. Maecenas malesuada. Praesent congue erat at massa. Sed cursus turpis vitae tortor. Donec posuere vulputate arcu. Phasellus accumsan cursus velit. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia Curae; Sed aliquam, nisi quis porttitor congue, elit erat euismod orci, ac placerat dolor lectus quis orci. Phasellus consectetuer vestibulum elit. Aenean tellus metus, bibendum sed, posuere ac, mattis non, nunc. Vestibulum fringilla pede sit amet augue. In turpis. Pellentesque posuere. Praesent turpis. Aenean posuere, tortor sed cursus feugiat, nunc augue blandit nunc, eu sollicitudin urna dolor sagittis lacus. Donec elit libero, sodales nec, volutpat a, suscipit non, turpis. Nullam sagittis. Suspendisse pulvinar, augue ac venenatis condimentum, sem libero volutpat nibh, nec pellentesque velit pede quis nunc. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia Curae; Fusce id purus. Ut varius tincidunt libero. Phasellus dolor. Maecenas vestibulum mollis diam. Pellentesque ut neque. Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas. In dui magna, posuere eget, vestibulum et, tempor auctor, justo. In ac felis quis tortor malesuada pretium. Pellentesque auctor neque nec urna. Proin sapien ipsum, porta a, auctor quis, euismod ut, mi. Aenean viverra rhoncus pede. Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas. Ut non enim eleifend felis pretium feugiat. Vivamus quis mi. Phasellus a est. Phas'
	},
	relatedAccounts: [],
	groupRiskStatusId: 2,
	isPrimaryAccount: false,
	pspIndexes: []
};

const account5 = {
	accountId: '216',
	accountName: 'C. Short dummy account',
	accountDesignation: 5,
	assertions: [
		{
			assertionId: '1',
			assertionAbbreviation: 'C',
			inherentRiskTypeId: 1
		},
		{
			assertionId: '2',
			assertionAbbreviation: 'E/O',
			inherentRiskTypeId: null
		},
		{
			assertionId: '3',
			assertionAbbreviation: 'M/V',
			inherentRiskTypeId: 1
		},
		{
			assertionId: '4',
			assertionAbbreviation: 'R&O',
			inherentRiskTypeId: 1
		},
		{
			assertionId: '5',
			assertionAbbreviation: 'P&D',
			inherentRiskTypeId: 2
		}
	],
	groupComponentAccount: {
		id: 8,
		rationale:
			'Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim. Donec pede justo, fringilla vel, aliquet nec, vulputate eget, arcu. In enim justo, rhoncus ut, imperdiet a, venenatis vitae, justo. Nullam dictum felis eu pede mollis pretium. Integer tincidunt. Cras dapibus. Vivamus elementum semper nisi. Aenean vulputate eleifend tellus. Aenean leo ligula, porttitor eu, consequat vitae, eleifend ac, enim. Aliquam lorem ante, dapibus in, viverra quis, feugiat a, tellus. Phasellus viverra nulla ut metus varius laoreet. Quisque rutrum. Aenean imperdiet. Etiam ultricies nisi vel augue. Curabitur ullamcorper ultricies nisi. Nam eget dui. Etiam rhoncus. Maecenas tempus, tellus eget condimentum rhoncus, sem quam semper libero, sit amet adipiscing sem neque sed ipsum. Nam quam nunc, blandit vel, luctus pulvinar, hendrerit id, lorem. Maecenas nec odio et ante tincidunt tempus. Donec vitae sapien ut libero venenatis faucibus. Nullam quis ante. Etiam sit amet orci eget eros faucibus tincidunt. Duis leo. Sed fringilla mauris sit amet nibh. Donec sodales sagittis magna. Sed consequat, leo eget bibendum sodales, augue velit cursus nunc, quis gravida magna mi a libero. Fusce vulputate eleifend sapien. Vestibulum purus quam, scelerisque ut, mollis sed, nonummy id, metus. Nullam accumsan lorem in dui. Cras ultricies mi eu turpis hendrerit fringilla. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia Curae; In ac dui quis mi consectetuer lacinia. Nam pretium turpis et arcu. Duis arcu tortor, suscipit eget, imperdiet nec, imperdiet iaculis, ipsum. Sed aliquam ultrices mauris. Integer ante arcu, accumsan a, consectetuer eget, posuere ut, mauris. Praesent adipiscing. Phasellus ullamcorper ipsum rutrum nunc. Nunc nonummy metus. Vestibulum volutpat pretium libero. Cras id dui. Aenean ut eros et nisl sagittis vestibulum. Nullam nulla eros, ultricies sit amet, nonummy id, imperdiet feugiat, pede. Sed lectus. Donec mollis hendrerit risus. Phasellus nec sem in justo pellentesque facilisis. Etiam imperdiet imperdiet orci. Nunc nec neque. Phasellus leo dolor, tempus non, auctor et, hendrerit quis, nisi. Curabitur ligula sapien, tincidunt non, euismod vitae, posuere imperdiet, leo. Maecenas malesuada. Praesent congue erat at massa. Sed cursus turpis vitae tortor. Donec posuere vulputate arcu. Phasellus accumsan cursus velit. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia Curae; Sed aliquam, nisi quis porttitor congue, elit erat euismod orci, ac placerat dolor lectus quis orci. Phasellus consectetuer vestibulum elit. Aenean tellus metus, bibendum sed, posuere ac, mattis non, nunc. Vestibulum fringilla pede sit amet augue. In turpis. Pellentesque posuere. Praesent turpis. Aenean posuere, tortor sed cursus feugiat, nunc augue blandit nunc, eu sollicitudin urna dolor sagittis lacus. Donec elit libero, sodales nec, volutpat a, suscipit non, turpis. Nullam sagittis. Suspendisse pulvinar, augue ac venenatis condimentum, sem libero volutpat nibh, nec pellentesque velit pede quis nunc. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia Curae; Fusce id purus. Ut varius tincidunt libero. Phasellus dolor. Maecenas vestibulum mollis diam. Pellentesque ut neque. Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas. In dui magna, posuere eget, vestibulum et, tempor auctor, justo. In ac felis quis tortor malesuada pretium. Pellentesque auctor neque nec urna. Proin sapien ipsum, porta a, auctor quis, euismod ut, mi. Aenean viverra rhoncus pede. Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas. Ut non enim eleifend felis pretium feugiat. Vivamus quis mi. Phasellus a est. Phas'
	},
	relatedAccounts: [],
	groupRiskStatusId: 2,
	isPrimaryAccount: false,
	pspIndexes: []
};

const account6 = {
	accountId: '212',
	accountName:
		'E. Trade accounts receivable accounts receivable accounts receivable accounts receivable accounts receivable accounts receivable accounts receivable accounts receivable accounts receivable accounts receivable accounts receivable',
	accountDesignation: 2,
	assertions: [
		{
			assertionId: '1',
			assertionAbbreviation: 'C',
			inherentRiskTypeId: 2
		},
		{
			assertionId: '2',
			assertionAbbreviation: 'E/O',
			inherentRiskTypeId: 1
		},
		{
			assertionId: '3',
			assertionAbbreviation: 'M/V',
			inherentRiskTypeId: 2
		},
		{
			assertionId: '4',
			assertionAbbreviation: 'R&O',
			inherentRiskTypeId: null
		},
		{
			assertionId: '5',
			assertionAbbreviation: 'P&D',
			inherentRiskTypeId: 1
		}
	],
	relatedAccounts: [],
	groupRiskStatusId: 1,
	isPrimaryAccount: true,
	groupComponentAccount: {
		id: 9,
		rationale: null
	},
	pspIndexes: [
		{
			pspIndexID: 1,
			pspIndexTitle: 'ABC PSP Indexes 01'
		}
	]
};

const account7 = {
	accountId: '214',
	accountName: 'C. Cash & short term deposits 2',
	accountDesignation: 5,
	assertions: [
		{
			assertionId: '1',
			assertionAbbreviation: 'C',
			inherentRiskTypeId: 1
		},
		{
			assertionId: '2',
			assertionAbbreviation: 'E/O',
			inherentRiskTypeId: null
		},
		{
			assertionId: '3',
			assertionAbbreviation: 'M/V',
			inherentRiskTypeId: 1
		},
		{
			assertionId: '4',
			assertionAbbreviation: 'R&O',
			inherentRiskTypeId: 1
		},
		{
			assertionId: '5',
			assertionAbbreviation: 'P&D',
			inherentRiskTypeId: 2
		}
	],
	groupComponentAccount: {
		id: 8,
		rationale:
			'Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim. Donec pede justo, fringilla vel, aliquet nec, vulputate eget, arcu. In enim justo, rhoncus ut, imperdiet a, venenatis vitae, justo. Nullam dictum felis eu pede mollis pretium. Integer tincidunt. Cras dapibus. Vivamus elementum semper nisi. Aenean vulputate eleifend tellus. Aenean leo ligula, porttitor eu, consequat vitae, eleifend ac, enim. Aliquam lorem ante, dapibus in, viverra quis, feugiat a, tellus. Phasellus viverra nulla ut metus varius laoreet. Quisque rutrum. Aenean imperdiet. Etiam ultricies nisi vel augue. Curabitur ullamcorper ultricies nisi. Nam eget dui. Etiam rhoncus. Maecenas tempus, tellus eget condimentum rhoncus, sem quam semper libero, sit amet adipiscing sem neque sed ipsum. Nam quam nunc, blandit vel, luctus pulvinar, hendrerit id, lorem. Maecenas nec odio et ante tincidunt tempus. Donec vitae sapien ut libero venenatis faucibus. Nullam quis ante. Etiam sit amet orci eget eros faucibus tincidunt. Duis leo. Sed fringilla mauris sit amet nibh. Donec sodales sagittis magna. Sed consequat, leo eget bibendum sodales, augue velit cursus nunc, quis gravida magna mi a libero. Fusce vulputate eleifend sapien. Vestibulum purus quam, scelerisque ut, mollis sed, nonummy id, metus. Nullam accumsan lorem in dui. Cras ultricies mi eu turpis hendrerit fringilla. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia Curae; In ac dui quis mi consectetuer lacinia. Nam pretium turpis et arcu. Duis arcu tortor, suscipit eget, imperdiet nec, imperdiet iaculis, ipsum. Sed aliquam ultrices mauris. Integer ante arcu, accumsan a, consectetuer eget, posuere ut, mauris. Praesent adipiscing. Phasellus ullamcorper ipsum rutrum nunc. Nunc nonummy metus. Vestibulum volutpat pretium libero. Cras id dui. Aenean ut eros et nisl sagittis vestibulum. Nullam nulla eros, ultricies sit amet, nonummy id, imperdiet feugiat, pede. Sed lectus. Donec mollis hendrerit risus. Phasellus nec sem in justo pellentesque facilisis. Etiam imperdiet imperdiet orci. Nunc nec neque. Phasellus leo dolor, tempus non, auctor et, hendrerit quis, nisi. Curabitur ligula sapien, tincidunt non, euismod vitae, posuere imperdiet, leo. Maecenas malesuada. Praesent congue erat at massa. Sed cursus turpis vitae tortor. Donec posuere vulputate arcu. Phasellus accumsan cursus velit. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia Curae; Sed aliquam, nisi quis porttitor congue, elit erat euismod orci, ac placerat dolor lectus quis orci. Phasellus consectetuer vestibulum elit. Aenean tellus metus, bibendum sed, posuere ac, mattis non, nunc. Vestibulum fringilla pede sit amet augue. In turpis. Pellentesque posuere. Praesent turpis. Aenean posuere, tortor sed cursus feugiat, nunc augue blandit nunc, eu sollicitudin urna dolor sagittis lacus. Donec elit libero, sodales nec, volutpat a, suscipit non, turpis. Nullam sagittis. Suspendisse pulvinar, augue ac venenatis condimentum, sem libero volutpat nibh, nec pellentesque velit pede quis nunc. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia Curae; Fusce id purus. Ut varius tincidunt libero. Phasellus dolor. Maecenas vestibulum mollis diam. Pellentesque ut neque. Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas. In dui magna, posuere eget, vestibulum et, tempor auctor, justo. In ac felis quis tortor malesuada pretium. Pellentesque auctor neque nec urna. Proin sapien ipsum, porta a, auctor quis, euismod ut, mi. Aenean viverra rhoncus pede. Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas. Ut non enim eleifend felis pretium feugiat. Vivamus quis mi. Phasellus a est. Phas'
	},
	relatedAccounts: [],
	groupRiskStatusId: 4,
	isPrimaryAccount: true,
	pspIndexes: []
};


const risk1 = {
	riskId: '1',
	riskName: 'Uncertain Tax Position',
	riskTypeId: 1, // 1 SR 2 FR 3 IR
	accounts: [account1],
	relatedRisks: [],
	groupRiskStatusId: 1,
	isPrimaryAccount: true
};

const risk2 = {
	riskId: '2',
	riskName:
		'Estimation uncertainty for tax matter is high due to the size of the assessment, complexity of transfer pricing, and significant judgement required. Estimation uncertainty for tax matter is high due to the size of the assessment, complexity of transfer pricing, and significant judgement required. Estimation uncertainty for tax matter is high due to the size of the assessment, complexity of transfer pricing, and significant judgement required.',
	riskTypeId: 2, // 1 SR 2 FR 3 IR
	accounts: [account3, account2],
	relatedRisks: [],
	groupRiskStatusId: 1,
	isPrimaryAccount: true
};

const risk3 = {
	riskId: '3',
	riskName:
		'Some other risk - Estimation uncertainty for tax matter is high due to the size of the assessment, complexity of transfer pricing, and significant judgement required. Estimation uncertainty for tax matter is high due to the size of the assessment, complexity of transfer pricing, and significant judgement required. Estimation uncertainty for tax matter is high due to the size of the assessment, complexity of transfer pricing, and significant judgement required.',
	riskTypeId: 3, // 1 SR 2 FR 3 IR
	accounts: [account3],
	relatedRisks: [],
	groupRiskStatusId: 1,
	isPrimaryAccount: true
};

const risk4 = {
	riskId: '4',
	riskName:
		'Risk of something - Estimation uncertainty for tax matter is high due to the size of the assessment, complexity of transfer pricing, and significant judgement required. Estimation uncertainty for tax matter is high due to the size of the assessment, complexity of transfer pricing, and significant judgement required. Estimation uncertainty for tax matter is high due to the size of the assessment, complexity of transfer pricing, and significant judgement required.',
	riskTypeId: 1, // 1 SR 2 FR 3 IR
	accounts: [account1],
	relatedRisks: [],
	groupRiskStatusId: 1,
	isPrimaryAccount: true
};

const risk5 = {
	riskId: '5',
	riskName: 'Uncertain Risk Position',
	riskTypeId: 1, // 1 SR 2 FR 3 IR
	accounts: [account1, account2, account3],
	relatedRisks: [risk3, risk4, risk1, risk2],
	groupRiskStatusId: 1,
	isPrimaryAccount: true
};

export default {
	mockedAccounts: {
		componentName: 'Component 1',
		engagementId: 1669759,
		accounts: [account3, account2, account1, account4, account5, account6],
		componentAccounts: [account3, account1, account2, account7]
	},
	mockedRisks: [risk2, risk3, risk1, risk5, risk4]
};
